import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { MinimumOrderValueModel } from '@libs/shop/models';
import { ProductPriceFormatterComponent } from '../../catalog/product-prices/product-price-formatter';

@Component({
  selector: 'ui-order-minimum-order-value',
  imports: [
    ProductPriceFormatterComponent,
  ],
  templateUrl: './order-minimum-order-value.component.html',
  styleUrl: './order-minimum-order-value.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.reached]': 'reached()',
    '[class.unreached]': '!reached()',
  },
})
export class OrderMinimumOrderValueComponent {
  public data: InputSignal<MinimumOrderValueModel> = input.required();
  public reached: Signal<boolean> = computed(() => this.data().total.status === 'reached');
}
